import React from "react";

export function isSSR() {
    return typeof window === "undefined" || typeof window.document === "undefined";
}

function enforceObject(value: any) {
    if (value === "") {
        return undefined;
    }

    if (typeof value === undefined || value === null) {
        return value;
    }

    if (typeof value !== "object") {
        return JSON.parse(String(value));
    }

    return value;
}

function enforceString(value: any) {
    if (typeof value === undefined || value === null) {
        return value;
    }

    if (typeof value === "object") {
        return JSON.stringify(value);
    }

    if (typeof value !== "string") {
        return String(value);
    }

    return value;
}

function enforceBoolean(value: any) {
    if (value === "") {
        return undefined;
    }

    if (typeof value === undefined || value === null) {
        return value;
    }

    if (typeof value === "string") {
        return value === "true";
    }

    return Boolean(value);
}

function enforceNumber(value: any) {
    if (value === "") {
        return undefined;
    }

    if (typeof value === undefined || value === null) {
        return value;
    }

    return Number(value);
}

const parsingMap = {
    object: enforceObject,
    string: enforceString,
    boolean: enforceBoolean,
    number: enforceNumber
};

export function parseStringifiedProps(
    component: React.FunctionComponent,
    props: Record<string, string>,
    propTypes: Record<string, string>
): React.ReactElement | null {
    if (isSSR()) {
        return component(props);
    }

    const parsedProps: Record<string, any> = {};

    for (const [key, value] of Object.entries(props)) {
        const parser = parsingMap[propTypes[key]];
        parsedProps[key] = parser ? parser(value) : value;
    }

    return component(parsedProps);
}
